'use client'

import styled from '@emotion/styled'
import Box from '@mui/material/Box'

const Wrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow-x: hidden;

  main {
    flex-grow: 1;
  }
`

export default function Body({ children }: { children: React.ReactNode }) {
  return <Wrapper>{children}</Wrapper>
}
